var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEngine(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 41.938,
    height: 27.984,
    viewBox: "0 0 41.938 27.984",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_60",
    "data-name": "Path 60",
    d: "M139.21,218h41.938v27.984H139.21Z",
    transform: "translate(0 0)",
    fill: "#ff7200"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Engine_No",
    "data-name": "Engine No",
    transform: "translate(-139.21 -218)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_59",
    "data-name": "Path 59",
    d: "M179.524,228.011a1.049,1.049,0,0,0-.942-.588h-3.748a1.048,1.048,0,0,0-1.049,1.048v2.221h-1.492v-2.226a1.048,1.048,0,0,0-1.043-1.049l-2.31-.011-1.44-3.267a1.049,1.049,0,0,0-.959-.625H160.91v-2.685h2.959a1.049,1.049,0,0,0,0-2.1H151.427a1.049,1.049,0,1,0,0,2.1h3.617v2.685h-4.932a1.048,1.048,0,0,0-.913.533l-1.055,1.869h-.718a3.45,3.45,0,0,0-3.446,3.446v2.286h-2.421a1.038,1.038,0,0,0-.257.036V226.06a1.049,1.049,0,1,0-2.1,0v12.919a1.049,1.049,0,0,0,2.1,0v-5.267a1.036,1.036,0,0,0,.257.036h2.42v5.082a3.5,3.5,0,0,0,3.491,3.491h3.364l3.959,3.959a1.047,1.047,0,0,0,.741.307h15.71a1.048,1.048,0,0,0,1.049-1.049v-3.02l1.492,0v1.98a1.048,1.048,0,0,0,1.047,1.049l3.828.007h0a1.049,1.049,0,0,0,.939-.583,20.761,20.761,0,0,0,1.542-8.621,20.348,20.348,0,0,0-1.62-8.334Zm-22.383-7.181h1.671v2.685h-1.671Zm20.815,22.621-2.075,0v-1.983a1.048,1.048,0,0,0-1.048-1.048h0l-3.589.006a1.048,1.048,0,0,0-1.047,1.048v3.018H155.968l-3.959-3.959a1.047,1.047,0,0,0-.741-.307h-3.8a1.4,1.4,0,0,1-1.394-1.394v-9.465a1.35,1.35,0,0,1,1.349-1.349h1.331a1.048,1.048,0,0,0,.913-.533l1.055-1.869h15.132l1.439,3.263a1.048,1.048,0,0,0,.954.626l1.947.009v2.231a1.048,1.048,0,0,0,1.048,1.049h3.589a1.049,1.049,0,0,0,1.049-1.049v-2.221h2a19.679,19.679,0,0,1,1.162,6.825,21.221,21.221,0,0,1-1.089,7.106Z",
    transform: "translate(0.005 -0.669)",
    fill: "#ff7200"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEngine);
export default __webpack_public_path__ + "static/media/engine.0d89998e23c3963ef7263416ff480b4f.svg";
export { ForwardRef as ReactComponent };